import {useState} from "react";
import "./image-with-loader.styles.scss";

/**
 * Image with a loading placeholder (shimmer + spinner) that fades the image
 * in once it has finished downloading, and shows a fallback on error.
 *
 * Any `width`/`height` are applied to the wrapper (not the <img>) so that
 * percentage widths and inline images keep working; the inner <img> just
 * fills the wrapper.
 */
const ImageWithLoader = ({
  src,
  alt = "",
  width,
  height,
  className = "",
  wrapperClassName = "",
  ...rest
}) => {
  const [status, setStatus] = useState("loading"); // loading | loaded | error

  const wrapperStyle = {};
  if (width) wrapperStyle.width = width;
  if (height) wrapperStyle.height = height;

  const sized = width || height ? "img-loader--sized" : "";

  return (
    <span
      className={`img-loader ${status} ${sized} ${wrapperClassName}`.trim()}
      style={wrapperStyle}
    >
      {status !== "loaded" && (
        <span className="img-loader-placeholder" aria-hidden="true">
          {status === "error" ? (
            <span className="img-loader-broken">⚠︎</span>
          ) : (
            <span className="img-loader-spinner" />
          )}
        </span>
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        loading="lazy"
        decoding="async"
        onLoad={() => setStatus("loaded")}
        onError={() => setStatus("error")}
        {...rest}
      />
    </span>
  );
};

export default ImageWithLoader;
